import workspaceQuery from '../../../graphql/queries/product/AssemblyAttributeConfigWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/product/AssemblyAttributeConfigListQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/AssemblyAttributeConfigQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/AssemblyAttributeConfigDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/AssemblyAttributeConfigMutation.graphql';
import fragment from '../../../graphql/fragments/product/AssemblyAttributeConfigFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const AssemblyAttributeConfig: EntityType = {
  type: 'AssemblyAttributeConfig',
  title: 'Assembly Attributes',
  formTitle: 'Assembly Attribute',
  formUrl: '/Products/Assembly/AssemblyAttributeConfig/Details/',
  workspaceUrl: '/Products/Assembly/AssemblyAttributeConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'ASSEMBLY_ATTRIBUTES',
};

export default AssemblyAttributeConfig;
